import cn from 'classnames';
import React from 'react';

import { useDictionariesFieldsMap } from '@src/reducers/dictionaries';
import { useCard } from '@src/reducers/product';
import { getDocumentsText } from '@src/utils/texts';

import styles from '../../styles.module.scss';
import { getRequirementsAge } from '../../utils/getRequirementsAge';

export const CustomerRequirements = () => {
    const { customerRequirements } = useCard();
    const { demands: demandsDictionary, microCreditsDocuments } = useDictionariesFieldsMap();
    const age = getRequirementsAge(customerRequirements);

    const documents =
        getDocumentsText(
            microCreditsDocuments,
            customerRequirements?.documents.filter(({ required }) => required),
        ) ?? [];

    const demands: string[] = customerRequirements.demands.map((demand) => demandsDictionary[demand]) ?? [];

    const items = [...demands, ...documents];

    return (
        <div className={cn(styles.twoColumnsWrapper, styles.oneRow)}>
            <div className={styles.cardItem}>
                <div className={styles.title}>Физические лица</div>
                <div className={styles.text}>{age}</div>
            </div>
            {items.length > 0 && (
                <div className={styles.cardItem}>
                    <div className={styles.title}>Требования и документы</div>
                    <div className={styles.text}>
                        <ul className={styles.list}>
                            {items.map((item, index) => (
                                <li key={item}>
                                    <div className={styles.text}>
                                        {item}
                                        {index === items.length - 1 ? '.' : ';'}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};
